import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from './../../shared';

@Component({
  selector: 'terms-of-use',
  template: require('./terms-of-use.component.html'),
  styles: [require('./terms-of-use.component.scss'), require('../static.scss')],
})
export class TermsOfUseComponent implements OnInit, AfterViewInit {

  constructor(private app: AppContext, private route: ActivatedRoute,  private seo: SeoService) {
    // Do stuff
  }

  
  title = 'Terms of Use - Linescape';
  description = 'Linescape is the first liner shipping search engine dedicated to ocean container schedules and routes with searches filtered by port, vessels or carrier.';
  
  ngOnInit() {
    this.seo.set(this.title, this.description);
  }

  loginToggle() {
    this.app.toggleLogin();
  }

  ngAfterViewInit() {
    this.route.params.subscribe(params => {
      if (params['scroll'] != null && params['scroll'] === 'true') {
        window.scrollTo(0, 0);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/static/terms-of-use/terms-of-use.component.ts